import { eidFactory } from './eidFactory';

const independentEid = eidFactory('app_sidebar.independent');
const internalEid = eidFactory('app_sidebar.internal');
const partnerEid = eidFactory('app_sidebar.partner');
const investorEid = eidFactory('app_sidebar.investor');

export {
  independentEid,
  internalEid,
  partnerEid,
  investorEid
};
